import Home from "./pages/Home";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Main from "./components/layout/Main";
import Employelist from "./components/Employees/Employelist";
import Paysheet from "./components/Paysheet/Paysheet";
import Auditlogs from "./components/Auditlogs/Auditlogs";
import HelpandSupport from "./components/HelpandSupport/HelpandSupport";
import Dashboard from "./components/Dashboard/Dashboard";
import { Contract } from "./components/contract/Contract";
import PaysheetDetails from "./components/Paysheet/PaysheetDetails";
import ForgotPassword from "./components/auth/Forgotpassword";
import CompanyDirectory from "./components/CompanyDirectory/CompanyDirectory";
import Tabs from "./components/UserManagement/Tabs"

const publicRoutes = [
  { path: "/sign-in", component: <SignIn /> },
  { path: "/contract", component: <Contract /> },
  { path: "/forgotpassword", component: <ForgotPassword /> },
];

const authProtectedRoutes = [
  // {path:'/sign-up', component:<SignUp/>},
  { path: "/dashboard", component: <Dashboard /> },

  { path: "/employees", component: <Employelist /> },
  { path: "/paysheet", component: <Paysheet /> },
  { path: "/auditlogs", component: <Auditlogs /> },
  { path: "/helpandsupport", component: <HelpandSupport /> },
  { path: "/paysheetDetails/:id", component: <PaysheetDetails /> },
  { path: "/companyDirectory", component: <CompanyDirectory /> },
  { path: "/user-management", component: <Tabs /> },
  { path: "/", component: <Main /> },
];

export { publicRoutes, authProtectedRoutes };
